import { render, staticRenderFns } from "./OffersPage.vue?vue&type=template&id=19ac9310"
import script from "./OffersPage.vue?vue&type=script&lang=js"
export * from "./OffersPage.vue?vue&type=script&lang=js"
import style0 from "./OffersPage.vue?vue&type=style&index=0&id=19ac9310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports